import React, { useContext } from 'react';
import classNames from 'classnames';
import { DragItem } from '@thd-olt-component-react/drag-and-drop';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { GroupItem } from '../group-item/GroupItem';
import { GroupIntersectionObserver } from './GroupIntersectionObserver';

const { arrayOf, bool, func, number, node, oneOfType, shape, string } = proptypes;

export const GroupContent = ({
  groupItems,
  group,
  loadMoreGroupItems,
  placeHolderConfig,
  uniqueItemMap,
  renderPod,
  showNumbering,
  groupIndex,
  groupChangeStatus,
  userSelect,
  renderDeleteButton,
  disablePlaceholders
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const { id: groupId, noOfItems = group?.items?.length } = group;

  const groupContentStyle = classNames(
    'sui-flex sui-flex-col sui-gap-3 sui-w-full',
    {
      'sui-px-2': isMobile
    }
  );

  return (
    <GroupIntersectionObserver
      groupId={groupId}
      numberOfItemsLoaded={groupItems.length}
      totalItemsInGroup={noOfItems}
      loadMore={loadMoreGroupItems}
      placeHolderConfig={placeHolderConfig}
      groupIndex={groupIndex}
      groupChangeStatus={groupChangeStatus}
      disablePlaceholders={disablePlaceholders}
    >
      <div
        className={groupContentStyle}
        data-testid={`group-items-${groupId}`}
      >
        {groupItems.map((uniqueItemKey, index) => {
          const item = uniqueItemMap[uniqueItemKey];
          return (
            <DragItem
              key={uniqueItemKey}
              id={uniqueItemKey}
              groupId={groupId}
              index={index}
              userSelect={userSelect}
              renderItem={(obj) => {
                return (
                  <GroupItem
                    index={index}
                    id={uniqueItemKey}
                    item={obj.item}
                    groupId={obj.groupId}
                    itemRef={obj.itemRef}
                    renderPod={renderPod}
                    numbering={showNumbering ? item?.numbering : null}
                    alert={item?.alert}
                    renderDeleteButton={renderDeleteButton}
                  />
                );
              }}
            />
          );
        })}
      </div>
    </GroupIntersectionObserver>
  );
};

GroupContent.displayName = 'GroupContent';

GroupContent.propTypes = {
  renderPod: func.isRequired,
  loadMoreGroupItems: func,
  group: shape({
    items: arrayOf(oneOfType([string, shape({
      id: string.isRequired,
      alert: oneOfType(
        [
          shape({
            status: string.isRequired,
            render: func,
          }),
          node
        ]
      )
    })])),
    id: string
  }).isRequired,
  showNumbering: bool.isRequired,
  placeHolderConfig: shape({
    height: number,
    numberOfLines: number,
    numberOfPlaceHolders: number
  }).isRequired,
  groupItems: arrayOf(string).isRequired,
  uniqueItemMap: shape({
    [string]: shape({
      id: string,
      numbering: string
    })
  }).isRequired,
  groupChangeStatus: arrayOf(bool).isRequired,
  groupIndex: number.isRequired,
  userSelect: string,
  renderDeleteButton: func,
  disablePlaceholders: bool
};

GroupContent.defaultProps = {
  loadMoreGroupItems: null,
  userSelect: 'none',
  renderDeleteButton: () => {},
  disablePlaceholders: false
};
